import * as THREE from 'three';
import type { MapDefinition } from '../../../shared/game/world-types.js';
import { terrainHeight } from '../../../shared/game/terrain.js';

const rest = new WeakMap<THREE.BufferGeometry, Float32Array>();
const point = new THREE.Vector3(), inverse = new THREE.Matrix4();
/** How far a vertex may leave the height under the decal's centre: a cave mouth's rock wall must not stand the ring up on end. */
export const DECAL_REACH = .45;
/** `y` held within the decal reach of `centre`. */
export function withinReach(y: number, centre: number, reach = DECAL_REACH) { return Math.max(centre - reach, Math.min(centre + reach, y)); }
/** Small UI shapes follow the surface instead of cutting through a slope. */
export function conformTerrainDecal(mesh: THREE.Mesh, map: MapDefinition, lift = .065) {
  if (!map.terrain || !mesh.visible) return;
  const positions = mesh.geometry.getAttribute('position') as THREE.BufferAttribute;
  let source = rest.get(mesh.geometry);
  if (!source) { source = Float32Array.from(positions.array); rest.set(mesh.geometry, source); }
  mesh.updateWorldMatrix(true, false);
  point.setFromMatrixPosition(mesh.matrixWorld);
  const centre = terrainHeight(map, point.x, point.z);
  inverse.copy(mesh.matrixWorld).invert();
  for (let i = 0; i < positions.count; i++) {
    point.fromArray(source, i * 3).applyMatrix4(mesh.matrixWorld);
    point.y = withinReach(terrainHeight(map, point.x, point.z), centre) + lift;
    point.applyMatrix4(inverse); positions.setXYZ(i, point.x, point.y, point.z);
  }
  positions.needsUpdate = true; mesh.geometry.computeBoundingSphere();
}
